export default __webpack_public_path__ + "static/media/cm.86d2318b.svg";